import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import Loading from './common/loading/Loading';
import App from './components/app/App';
import { UserProvider } from './contexts/user-context/UserProvider';
// import { MainAppBarProvider } from './contexts/main-app-bar-context/MainAppBarProvider';
//
import 'animate.css/animate.min.css';
import 'aos/dist/aos.css';
import 'react-circular-progressbar/dist/styles.css';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import 'react-notifications-component/dist/theme.css';
import 'react-phone-number-input/style.css';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import { CartProvider } from './contexts/cart-context/CartContext';
import { CatsProvider } from './contexts/cats-context/CatsContext';
import { FilterCatsProvider } from './contexts/filter-cats/FilterCatsContext';
import { GeneralSettingsProvider } from './contexts/general-settings-context/GeneralSettingsContext';
import { MyNotificationsProvider } from './contexts/notifications-context/MyNotificationsContext';
import { SelectedPageProvider } from './contexts/selected-page-context/SelectedPageContext';
import { SharedAppProvider } from './contexts/shared-app-context/SharedAppContext';
import './scss/index.scss';

ReactDOM.render(
  <Suspense fallback={<Loading />}>
    <UserProvider>
      <Router>
        <MyNotificationsProvider>
          <SelectedPageProvider>
            <CartProvider>
              <GeneralSettingsProvider>
                <FilterCatsProvider>
                  <CatsProvider>
                    <SharedAppProvider>
                      <App />
                    </SharedAppProvider>
                  </CatsProvider>
                </FilterCatsProvider>
              </GeneralSettingsProvider>
            </CartProvider>
          </SelectedPageProvider>
        </MyNotificationsProvider>
      </Router>
    </UserProvider>
  </Suspense>,
  document.getElementById('root')
);
